<template>
  <chat
    :items="filteredMessages"
    v-bind="$attrs"
    :default-message="defaultMessage"
    @message="sendMessage"
  />
</template>

<script>
/** Put all the logic here */

import { mapGetters } from 'vuex';
import Chat from './Chat';

export default {
  name: 'ChatContainer',
  components: {
    Chat,
  },
  inheritAttrs: false, // props are passed down to the component bia $attrs
  data() {
    return {
      defaultMessage: `
        Welcome! Everyone in the chat can see your name and messages with Everyone 
        — and can share them with others, please do not share any personal details in the chat.`,
    };
  },
  computed: {
    ...mapGetters({
      formattedMessages: 'chat/formattedMessages',
    }),
    filteredMessages() {
      return this.formattedMessages.filter((item) => item.attributes.type === 'user');
    },
  },
  methods: {
    sendMessage(message) {
      this.$store.dispatch('chat/sendMessage', {
        message,
        attributes: {
          type: 'user',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
